import React from "react";
import Popup from "./BasePopup";
import { scrimStatusUpdate } from "../../api/scrim.api";
import { useNavigate, useParams } from 'react-router-dom';
import { toastError } from "../../Utilities/toast";

const CancelScrimPopup = ({ isOpen, title, onClose, scrimId }) => {
    const navigate = useNavigate()

    const cancelScrim = async () => {
        try {
          const response = await scrimStatusUpdate({ _id: scrimId, status: "Canceled" });
          if (response?.success) {
            navigate(`/private-contest/private-contest/list`)
          } else {
            toastError(response.data.errors[0].msg)
          }
        } catch (error) {
          console.error('Error:', error);
        }
    };

  return (
    <Popup isOpen={isOpen} title={title} onClose={onClose}>
        <div className="tournament-joining-popup-step2 mt-4 mb-4">
            <div className="tournament-joining-popup-entryfee text-center d-flex justify-content-center mb-4">
                <div className="tournament-joining-popup-entryfee-text">
                    Are you sure you want to cancel ?
                </div>
            </div>
            <div className="d-flex justify-content-center">
                <button className="submit-button w-25 me-2" onClick={() => onClose()}>No</button>
                <button className="submit-button w-25" onClick={() => cancelScrim()}>Yes</button>
            </div>
        </div>
    </Popup>
  );
};

export default CancelScrimPopup;